import { ActionIcon, Flex, Menu } from "@mantine/core";
import { IconDotsVertical } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export const RowActionsMenu = ({ primary, items = [], menuWidth = 180, className, dropdownClassName }) => {
    const { t } = useTranslation();

    return (
        <Flex className={className} wrap="nowrap" gap={4} align="center" justify="flex-start">
            {primary}

            {/* A row with nothing more to offer gets no empty menu. */}
            {items.length > 0 && <Menu
                width={menuWidth}
                position="bottom-end"
                withinPortal
                classNames={dropdownClassName ? { dropdown: dropdownClassName } : undefined}
            >
                <Menu.Target>
                    <ActionIcon variant="default" color="dark" size="md" aria-label={t('common.moreActions')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M4.00041 7.99998V7.66665M12.0004 7.99998V7.66665M8.00042 7.99998V7.66665M4.66707 7.99998C4.66707 7.63185 4.36859 7.33331 4.00041 7.33331C3.63221 7.33331 3.33374 7.63185 3.33374 7.99998C3.33374 8.36818 3.63221 8.66665 4.00041 8.66665C4.36859 8.66665 4.66707 8.36818 4.66707 7.99998ZM12.6671 7.99998C12.6671 7.63185 12.3686 7.33331 12.0004 7.33331C11.6322 7.33331 11.3338 7.63185 11.3338 7.99998C11.3338 8.36818 11.6322 8.66665 12.0004 8.66665C12.3686 8.66665 12.6671 8.36818 12.6671 7.99998ZM8.66709 7.99998C8.66709 7.63185 8.36862 7.33331 8.00042 7.33331C7.63222 7.33331 7.33375 7.63185 7.33375 7.99998C7.33375 8.36818 7.63222 8.66665 8.00042 8.66665C8.36862 8.66665 8.66709 8.36818 8.66709 7.99998Z" stroke="#212529" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </ActionIcon>
                </Menu.Target>
                <Menu.Dropdown>
                    {items}
                </Menu.Dropdown>
            </Menu>}
        </Flex>
    );
};
